import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import api from '../api';

export default function StudentRegistration() {
    const [formData, setFormData] = useState({
        first_name: '',
        username: '',
        password: '',
    });
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');
        try {
            await api.post('/teacher/students/', formData);
            setMessage('학생이 성공적으로 등록되었습니다.');
            setFormData({ first_name: '', username: '', password: '' }); // Clear form
        } catch (err) {
            setError('등록에 실패했습니다. 입력 내용을 확인해주세요.');
            console.error(err);
        }
    };

    return (
        <Layout>
            <Link to="/teacher" className="back-link">선생님 홈으로</Link>
            <div style={{ maxWidth: '400px', margin: 'auto' }}>
                <h1>학생 등록</h1>
                <form onSubmit={handleSubmit}>
                    <p>이름</p>
                    <input
                        type="text"
                        name="first_name"
                        value={formData.first_name}
                        onChange={handleChange}
                        required
                    />
                    <p>아이디</p>
                    <input
                        type="text"
                        name="username"
                        value={formData.username}
                        onChange={handleChange}
                        required
                    />
                    <p>비밀번호</p>
                    <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                    />
                    <button type="submit">등록</button>
                </form>
                {message && <p className="message success">{message}</p>}
                {error && <p className="message error">{error}</p>}
            </div>
        </Layout>
    );
}

